<script>
export default {
	inheritAttrs: false,
	props: {
		order: Object,
	},
	computed: {
		expreso() {
			return this.order.deliveries?.[0].data?._expreso
		},
	},
}
</script>

<template>
	<CardLayout v-if="expreso" class="mb-6">
		<template #title> Expreso seleccionado</template>
		<div>
			<b>{{ expreso.name }}</b>
		</div>
	</CardLayout>
</template>

